import { Auth } from 'aws-amplify';
import { toast } from 'react-toastify';

const baseURL = process.env.REACT_APP_BILLING_SERVER_API_URL ?? '';

export const handyFetchToken = async () => {
  const headers = new Headers();

  try {
    const xAccessToken = (await Auth.currentSession()).getAccessToken().getJwtToken();
    headers.set('x-access-token', xAccessToken);
  } catch (error) {
    console.error('Error retrieving user session: ', error);
  }
  const rawResponse = await fetch(`${baseURL}/handy-token`, {
    headers,
  });

  if (!rawResponse.ok) {
    if (rawResponse.status !== 401 && rawResponse.status !== 404) {
      toast.error(rawResponse.status + ' ' + rawResponse.statusText);
    }
    throw new Error(rawResponse.statusText);
  } else {
    return await rawResponse.json();
  }
};
